import { fetchFromApi } from './api';

export interface ApiUserPreferences {
  system: string;
  timeFormat: string;
}

export const getPreferences = async () : Promise<ApiUserPreferences> => {
  const result = fetchFromApi('/api/preferences');

  return result;
}
